import { render, staticRenderFns } from "./BalanceIcon.vue?vue&type=template&id=46ddf9ee&scoped=true&"
import script from "./BalanceIcon.vue?vue&type=script&lang=js&"
export * from "./BalanceIcon.vue?vue&type=script&lang=js&"
import style0 from "./BalanceIcon.vue?vue&type=style&index=0&id=46ddf9ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ddf9ee",
  null
  
)

export default component.exports